module.exports = __webpack_public_path__ + "static/img/15.2b721276.png";